import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useResponsibleQuery } from "../../user/hooks/useResponsibleQuery.ts";
import { useTranslation } from "../../localization/useTranslation.ts";

export interface ResponsibleFieldProps {
    responsibleId: string | null | undefined;
    isLoading: boolean;
    onChange: (responsibleId: string | null) => void;
    readOnly?: boolean;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
    toolTipText?: string;
    warningText?: string;
}

function ResponsibleField(props: ResponsibleFieldProps) {
    const { translateString } = useTranslation();
    const responsibleQuery = useResponsibleQuery(!props.isPreview);
    const responsibleData = responsibleQuery.userData ? responsibleQuery.data(props.responsibleId)?.map((d) => ({ ...d })) : undefined;

    return (
        <DotLegalSelect
            onChange={props.readOnly ? () => {} : (user) => props.onChange(user)}
            label={translateString("responsible")}
            options={responsibleData}
            placeholder={translateString("responsible")}
            selectedItem={props.responsibleId ?? null}
            disabled={props.disabled}
            isLoading={(responsibleQuery.isLoading || props.isLoading) && !props.readOnly}
            toolTipText={props.toolTipText}
            errorText={props.errorText}
            warningText={props.warningText}
            noOptionsLabel={translateString("noOptions")}
            disableClearable
        />
    );
}

export default ResponsibleField;
